<template>
  <div class="main" v-title data-title="注册 - 试剂采购库存管理系统">
    <div class="logo-title">
      <h2>
        {{ platformInfo.sysName }}
      </h2>
    </div>
    <div v-if="step == 'userInfo' && addType" class="zcBox">
      <div class="title">注册账号</div>

      <div class="box">
<!--        <div class="normalLine">-->
<!--          <div class="l_t">注册邀请人</div>-->
<!--          <div class="r_t">{{ registeredUserInfo.inviterUser }}</div>-->
<!--        </div>-->
        <div class="input_line">
          <div class="l_t" style="color: #666">真实姓名<span class="requiedText">*</span></div>
          <input
              class="r_ipt"
              v-model="registeredUserInfo.nickName"
              type="text"
              placeholder="请输入您的姓名"
          />
        </div>
        <div class="input_line">
          <div class="l_t">登录帐号<span class="requiedText">*</span></div>
          <input
              class="r_ipt"
              v-model="registeredUserInfo.accountName"
              type="text"
              placeholder="请设置您的登录账号"
          />
        </div>
        <div class="input_line">
          <div class="l_t">邮箱
            <el-tooltip
                class="item"
                effect="light"
                content="将用于接收注册页面成功通知和找回密码"
                placement="right-start">
              <i class="el-icon-question" />
            </el-tooltip>
            <span class="requiedText"> *</span></div>
          <input
              class="r_ipt"
              v-model="registeredUserInfo.email"
              type="text"
              placeholder="请输入您的邮箱地址"
          />
        </div>
        <div class="input_line">
          <div class="l_t">登录密码<span class="requiedText">*</span></div>
          <input
              class="r_ipt"
              v-model="registeredUserInfo.password"
              type="password"
              autocomplete="new-password"
              placeholder="请设置您的登录密码"
          />
        </div>
        <div class="input_line">
          <div class="l_t">密码确认<span class="requiedText">*</span></div>
          <input
              class="r_ipt"
              v-model="registeredUserInfo.rePassword"
              type="password"
              placeholder="请再次确认您的登录密码"
          />
        </div>
        <div class="input_line">
          <div class="l_t">手机号<span class="requiedText">*</span></div>
          <input
              class="r_ipt"
              v-model="registeredUserInfo.phone"
              type="text"
              placeholder="请输入手机号"
          />
        </div>
        <div class="input_line">
          <div class="l_t">邀请码<span class="requiedText" v-show="1 == addType">*</span></div>
          <input
              class="r_ipt"
              v-model="registeredUserInfo.inviterCode"
              type="text"
              placeholder="请输入邀请人的注册邀请码"
          />
        </div>
      </div>
      <div class="div-item">
        <el-row>
          <el-col :span="10">
            <el-button class="bottom-btn" @click="backUserInfo">上一步</el-button>
          </el-col>
          <el-col :span="13">
            <el-button class="bottom-btn" type="primary"  @click="addUserInfo">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-else-if="step=='name'" class="login-container">
      <div class="login-content">
        <img
            src="../../assets/images/register1.png"
            class="login-left"
            alt=""
        />
        <div class="login-info">
          <div class="div-item">
            <h2>实验室所属机构</h2>
            <div class="h2-title-children-info">
              <el-row>
                <el-col :span="10">
                  <el-cascader
                      placeholder="请选择城市"
                      ref="refValue"
                      :options="addressList"
                      :props="optionProps"
                      v-model="addressName"
                      @change="chooseArea"></el-cascader>
                </el-col>
                <el-col :span="14">
                  <el-input placeholder="请输入所属机构全名" v-model="schoolTaskInfo.schoolName" style="margin-left: 20px"></el-input>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="div-item">
            <h2>实验室命名</h2>
            <div class="h2-title-children-info">
              <el-row>
                <el-col :span="24">
                  <el-input placeholder="示例：×××（导师姓名）课题组" v-model="schoolTaskInfo.schoolTaskName" ></el-input>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="div-item">
            <el-row>
              <el-col :span="12">
                <el-button class="bottom-btn" @click="previousStep ">上一步</el-button>
              </el-col>
              <el-col :span="12">
                <el-button class="bottom-btn" type="primary" style="width: 130px" @click="addSchoolTask">创建我的实验室</el-button>
              </el-col>
            </el-row>
          </div>

        </div>
      </div>
    </div>
    <div v-else-if="step=='direction'" class="login-container">
      <div class="login-content">
        <img
            src="../../assets/images/register2.png"
            class="login-left"
            alt=""
        />
        <div class="login-info">
          <div class="div-item">
            <h2>我的实验室研究方向</h2>
            <div class="h2-title-children-info checkbox-group">
              <el-checkbox-group v-model="checkedDirection" class="checkbox-group" @change="checkboxGroupChange">
                <el-checkbox
                    :class="direction.id==6?'last-checkbox':'checkbox-item'"
                    v-for="direction in directionList"
                    :label="direction.id" :key="direction.id">{{direction.label}}</el-checkbox>
                <input size="mini" v-model="directionOtherContent" :disabled="!checkedDirection.includes(6)" style="width: 120px;border-bottom: 1px solid #ccc"/>
              </el-checkbox-group>
            </div>
          </div>

          <div class="div-item bottom-btn-parent">
            <el-button class="bottom-btn" type="primary" @click="directionCommit">下一步</el-button>
            <el-button class="bottom-btn" @click="previousStep ">上一步</el-button>
          </div>

        </div>
      </div>
    </div>
    <div v-else-if="step=='versionChoose'" class="login-container">
      <div class="login-content">
        <img
            src="../../assets/images/register3.png"
            class="login-left"
            alt=""
        />
        <div class="login-info">
          <div class="div-item">
            <h2>我的实验室需要</h2>
            <div class="h2-title-children-info">
              <el-row :gutter="20" v-for="version in versionList" :key="version.title" style="margin-top: 40px">
                <el-col :span="7">
                  <div class="grid-content bg-purple" style="margin-top: 4px">
                    <el-radio  v-model="versionInfo" :label="version.version" >
                      {{version.title}}
                    </el-radio>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="grid-content bg-purple">
                    <div >{{version.content}}</div>
                  </div>
                </el-col>
              </el-row>

            </div>
          </div>
          <div class="div-item bottom-btn-parent">
            <el-button class="bottom-btn" type="primary" @click="versionChooseNextStep">下一步</el-button>
            <el-button class="bottom-btn" @click="previousStep ">上一步</el-button>
          </div>

        </div>
      </div>
    </div>
    <div v-else-if="step=='chooseVersionPro'" class="login-container">
      <div class="login-content">
        <img
            src="../../assets/images/register3.png"
            class="login-left"
            alt=""
        />
        <div class="login-info">
          <div class="div-item">
            <h2>专业版</h2>
            <div class="h2-title-children-info">
              <div style="font-weight: 600;margin-top: 30px;margin-bottom: 10px">1、请选择想要的追踪功能：</div>
              <el-row :gutter="20" v-for="version in versionProList" :key="version.title" style="margin-top: 10px;margin-left: 10px">
                <el-col :span="10">
                  <div class="grid-content bg-purple" style="margin-top: 4px">
                    <el-radio  v-model="proVersionObj.trace" :label="version.version" >
                      {{version.title}}
                    </el-radio>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="grid-content bg-purple">
                    <div >{{version.content}}</div>
                  </div>
                </el-col>
              </el-row>
              <div style="font-weight: 600;margin-top: 50px;margin-bottom: 20px;">2、请选择是否需要 "盘点" 功能：</div>
                <div class="grid-content bg-purple" style="margin-top: 4px;margin-left: 20px;">
                  <el-radio style="margin-right: 80px" v-model="proVersionObj.inventory" :label="version.value" v-for="version in inventoryList" :key="version.label" >
                    {{version.label}}
                  </el-radio>
                </div>
            </div>
          </div>
          <div class="div-item bottom-btn-parent">
            <el-button class="bottom-btn" type="primary" @click="proVersionChooseNextStep">下一步</el-button>
            <el-button class="bottom-btn" @click="previousStep ">上一步</el-button>
          </div>

        </div>
      </div>
    </div>
    <div v-else-if="step=='versionInfo'" class="login-container">
      <div class="login-content" style="width: 20%;height: 60%">

        <div class="login-info">
          <div class="div-item" style="margin-top: 10px">
            <div>
              <h2>{{currentVersion.title}}</h2>
              <ul style="list-style: initial;margin-left: 20px;margin-top: 20px">
                <li v-for="(item,id) in currentVersion.details" :key="id" class="li-item">
                  <span :class="item.highLight?'high-light':''">{{item.content}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="div-item bottom-btn-parent">
            <el-button class="bottom-btn" type="primary" @click="finish">完成</el-button>
            <el-button class="bottom-btn" @click="previousStep ">上一步</el-button>
          </div>


        </div>
      </div>
    </div>
    <div v-else-if="step=='finish'" class="login-container">
      <div class="login-content" style="width: 20%;height: 60%">

        <div class="login-info">
          <div class="div-item" style="text-align: center">
            <div>
              <h2>
                <i class="el-icon-success" style="font-size: 80px;color: #1a6ffc;"></i>
              </h2>
              <p style="font-size: 22px; font-weight: 800;margin-top: 40px">欢迎来到您的实验室</p>
              <p style="margin-top: 30px; font-weight: 400;font-size: 15px">出色的研究始于出色的实验室管理，让信息化加速研究进程</p>
              <p style="margin-top: 30px; font-weight: 400;font-size: 15px;color: orange">账号信息待审核！！</p>
            </div>
          </div>
          <div style="text-align: center;margin-top: 30%">
            <el-button  type="primary" @click="go">GO</el-button>
          </div>


        </div>
      </div>
    </div>
    <div v-else-if="step=='think'" class="login-container">
      <div class="login-content" style="width: 20%;height: 60%">

        <div class="login-info">
          <div class="div-item" style="text-align: center">
            <div>
              <h2>
                <i class="el-icon-success" style="font-size: 80px;color: #1a6ffc;"></i>
              </h2>
              <p style="font-size: 22px; font-weight: 800;margin-top: 40px">感谢您的注册</p>
              <p style="margin-top: 30px; font-weight: 400;font-size: 15px">账号信息正在审核中，审核结果将在半天内发送至您的邮箱，注意查收！</p>
            </div>
            <div style="margin-top: 40px;">
              <el-button size="medium" @click="backLogin" round>返回登录页</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="step=='error'"><h1>error!</h1></div>
    <!-- 备案号 -->
    <div class="record">洛济化学技术(上海)有限公司 沪ICP备2021028033号-1</div>


    <div>
      <el-dialog title="账号注册" :visible.sync="addRegisterRadio" width="30%" :show-close="false">
        <div>
          <el-row>
            <el-col><span><el-radio v-model="addRadio" label="1">加入已有课题组</el-radio></span></el-col>
          </el-row>
          <el-row style="padding-top: 25px;">
            <el-col>
              <span><el-radio v-model="addRadio" label="2">创建新课题组</el-radio></span>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="backRegisterRadioClick">取 消</el-button>
          <el-button type="primary" @click="addRegisterRadioClick">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import addressData from "@/components/area.json";
let Base64 = require('js-base64').Base64
export default {

  data() {
    return {
      addRadio: null,
      addRegisterRadio: false,
      businessNo:null,
      versionDetails:[
        {
          version:10,
          title:"基础版",
          details:[
            {
              highLight:false,
              content:'搜索：搜物性、搜库存、搜在售',
            },{
              highLight:false,
              content:'采购：三方比价、一键下单、直连库存',
            },{
              highLight:false,
              content:'库存：简单的登记和出入库管理',
            },{
              highLight:false,
              content:'试剂共享共建，跨组领借还',
            },{
              highLight:false,
              content:'经费管理',
            },{
              highLight:false,
              content:'报表和统计',
            },{
              highLight:false,
              content:'文档库',
            },{
              highLight:false,
              content:'20个账号',
            },{
              highLight:false,
              content:'不限搜索次数',
            },{
              highLight:false,
              content:'3000试剂库存量',
            },
          ]
        },{
          version:40,
          title:"专业版",
          details:[
            {
              highLight:false,
              content:'基础版所有功能',
            }, {
              highLight:false,
              content:'智能推荐试剂存放位置以及销毁方法',
            }, {
              highLight:false,
              content:'物联网机械盘点省时省力',
            }, {
              highLight:false,
              content:'增强的历史数据查询',
            }, {
              highLight:false,
              content:'增强的统计报表和分析',
            }, {
              highLight:false,
              content:'支持连接电子实验记录本',
            }, {
              highLight:false,
              content:'支持连接PDA扫码枪、标签打印机(另外采购)',
            }, {
              highLight:false,
              content:'采支持连接蓝牙锁、智能锁开关(另外采购)',
            }, {
              highLight:false,
              content:'合理需求的快速响应和改进',
            }, {
              highLight:false,
              content:'不限用户账号数量',
            }, {
              highLight:false,
              content:'不限试剂库存数量',
            },
          ]
        },
        {
          version:20,
          title:"折中的库存管理有哪些功能",
          details:[
            {
              highLight:false,
              content:'费用: 软件终生免费，硬件3000元/套，一般一个实验室一套',
            }, {
              highLight:false,
              content:'简单的试剂登记、查询位置、移除等功能',
            }, {
              highLight:false,
              content:'物联网技术加持盘点功能，原先花一周时间盘点，现在只需半天',
            }, {
              highLight:false,
              content:'1.14亿试剂数据库搜索查询基本信息',
            }, {
              highLight:false,
              content:'主流试剂供应商三方比价、一键下单',
            }, {
              highLight:false,
              content:'采购下单直连入库，免登记',
            }, {
              highLight:false,
              content:'采购额度分配与管理',
            }, {
              highLight:false,
              content:'采购数据统计与分析',
            }, {
              highLight:false,
              content:'试剂跨组公开与保密',
            }, {
              highLight:false,
              content:'操作日志方便检索',
            },
          ]
        },
      ],
      versionInfo:'',
      versionList:[
        {
          version:10,
          title:'基础版 (0元/年，适合小型实验室或个人)',
          content:''
        }, {
          version:40,
          title:'专业版 (2280元/年，适合大、中、小型实验室)',
          content:''
        },
        // {
        //   version:10,
        //   title:'简单的库存管理',
        //   content:'(我管理的非常好，组员们都很自觉，基本不需要盘点)'
        // }, {
        //   version:40,
        //   title:'精细的库存管理',
        //   content:'(我希望追踪试剂痕迹，实现全生命周期管理，为电子实验记录本做好前期准备)'
        // }, {
        //   version:20,
        //   title:'折中的库存管理',
        //   content:'(我不需要精细管理，但是我也很头疼时不时的盘点和不定期的检查)'
        // },
      ],
      versionProList:[
        {
          version:20,
          title:'线上追踪领借还',
          content:''
        }, {
          version:40,
          title:'线上线下双追踪详细操作(需要另行配置PDA扫码枪、标签打印机)',
          content:''
        },
      ],
      proVersionObj:{
        trace:null,
        inventory:null,
      },
      inventoryList:[
        {label:'需要',value:'true'},
        {label:'不需要',value:'false'},
      ],
      checkedDirection: [],
      directionList:[
        {
          id:1,
          label:'化学',
        },
        {
          id:2,
          label:'生物'
        },
        {
          id:3,
          label:'材料'
        },
        {
          id:4,
          label:'医学'
        },
        {
          id:5,
          label:'农学'
        },
        {
          id:6,
          label:'其他'
        },
      ],
      directionOtherContent:'',
      step:'userInfo',
      stepArr:['userInfo','name','direction','versionChoose','versionInfo','think'],
      schoolTaskInfo:{
        city:"",
        schoolName:'',
        schoolTaskName:'',
      },
      itemAddress: {
        address: "",
        area: "",
        areaId: "",
        city: "",
        cityId: "",
        def: false,
        fullName: "",
        phone: "",
        province: "",
        provinceId: "",
      },
      optionProps: {
        value: "id",
        label: "fullName",
        children: "children",
      },
      registeredUserInfo: {
        inviterUser: "",
        schoolName: "",
        schoolId: "",
        taskId: "",
        taskName: "",
        accountName: "",
        nickName: "",
        password: "",
        rePassword: "",
        icCard: "",
        inviterCode: "",
        inviterId: "",
        email: "",
        phone:"",
      },
      locationtype: "",
      addressName: [],
      addressList:null,
      platformInfo: "",
      addType: null,
    };
  },
  created() {
    this.getLoker();
    this.addressList = addressData;
    const addType = this.addType;
    console.log(addType);
    if(!addType){
      this.addRegisterRadio = true;
    }
  },
  mounted() {

  },
  computed:{
    currentVersion() {
      return this.versionDetails.find(item => item.version === this.versionInfo);
    },
  },
  methods: {
    backRegisterRadioClick(){
      this.addRegisterRadio = false;
      this.addRadio=1;
      this.$router.push("/");
    },
    backUserInfo(){
      this.addType = null;
      this.addRegisterRadio = true;
    },
    backLogin(){
      this.$router.push("/");
    },
    addRegisterRadioClick(){
      const addRadio = this.addRadio;
      if(!addRadio){
        this.$message.error("请至少选择一项");
        return;
      }
      this.addType = addRadio;
      this.addRegisterRadio = false;
      console.log(this.addType);
    },
    async addUserInfo() {

      const {
        inviterCode,
        accountName,
        nickName,
        password,
        rePassword,
        inviterId,
        email,
        icCard,
        phone,
      } = this.registeredUserInfo;
      const params = {
        'businessType': 'Member',
        'realName': nickName,
        'nickName': nickName,
        'loginMember': accountName,
        'accountName': accountName,
        'email': email,
        'password': password,
        'reallyPassword': rePassword,
        'phone': phone,
        inviterCode,
        inviterId,
        icCard,
      };
      params.addType = this.addType;
      let errText = ''
      if (!params.addType) {
        errText = '请选择是加入已有课题组或创建新课题组'
      } else if (!accountName) {
        errText = '缺少登录账号'
      } else if (!nickName) {
        errText = '缺少真实姓名'
      } else if (!password) {
        errText = '缺少登录密码'
      } else if (!rePassword) {
        errText = '缺少确认登录密码'
      } else if (!email) {
        errText = '缺少邮箱'
      } else if (!phone) {
        errText = '缺少手机号'
      } else if (!phone.match(/^1[3-9]\d{9}$/)) {
        errText = "请输入正确手机号"
      } else if (password !== rePassword) {
        errText = '两次输入密码不同'
      }else if (1 == this.addType && !inviterCode) {
        errText = '缺少邀请码'
      }
      if (errText) {
        this.$message({
          showClose: true,
          message: errText,
          type: "error",
        });
        return;
      }
      // let flag = await this.checkRegister(params);
      // if (!flag) {
      //   return;
      // }
      //本组注册
      if (1 == this.addType) {
        this.currentRegister(params);
        return;
      }

      //外组注册
      this.$apiFetch.post("/lockerInvite/preparationInvite", params).then((res) => {
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        } else {
          this.businessNo = res.data;
          localStorage.setItem('businessNo', res.data);
          this.nextStep();
        }
      }).catch(err=>{
        this.$message.error("注册失败")
      });

    },


    currentRegister(params){
      this.$apiFetch.post("/lockerUser/regist", params).then((res) => {
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        } else {
          this.$message({
            showClose: true,
            message: `注册成功,您是第${res.data}位注册成功的用户！`,
            type: "success",
          });
          this.$router.push("/");
        }
      });
    },
    async proVersionChooseNextStep(){
      if(!this.proVersionObj.trace || !this.proVersionObj.inventory){
        this.$message.error("请选择!")
        return;
      }
      let params = {
        'businessNo':this.businessNo,
        'businessType':'proVersion',
        'trace':this.proVersionObj.trace,
        'pandian':this.proVersionObj.inventory
      }
      let result = await this.commit(params)
      this.nextStep()
    },
    checkboxGroupChange(){
      if(!this.checkedDirection.includes(6)){
        // this.directionOtherContent = ""
      }
    },
    async directionCommit(){
      let tempCheck = []
      if(this.checkedDirection.length<=0){
        this.$message.error("请至少选择一项");
        return ;
      }
      for(let i=0;i<this.checkedDirection.length;i++){
        let item = this.checkedDirection[i]
        tempCheck.push(item)
        if(item == '6'){
          if(this.directionOtherContent != '' && this.directionOtherContent != undefined){
            tempCheck.push("其他("+this.directionOtherContent+")")
          }
        }
      }
      let params = {
        'businessNo':this.businessNo,
        'businessType':'Research',
        'researchs':tempCheck
      }
      console.log(params)
      let result = await this.commit(params)
      // if(result){
        this.nextStep()
      // }
    },
    //添加到后端
    async commit(params){
      this.$apiFetch.post("/lockerInvite/preparationInvite", params).then((res) => {
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        } else {
          return res.data;
        }
      }).catch(err=>{
        this.$message.error("请求失败！")
      });
    },
    go(){
      this.$message({
        showClose: true,
        message: "账号信息待审核！！",
        type: "warning",
        duration:0
      });
      let userObj = localStorage.getItem("tempUser")
      let user = JSON.parse(userObj);
      this.setCookie(user.accountName,user.pwd,30)
      localStorage.removeItem("tempUser")
      this.$router.push("/")
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
          "userName" +
          "=" +
          escape(c_name) +
          ";path=/;expires=" +
          exdate.toGMTString();
      window.document.cookie =
          "userPwd" +
          "=" +
          escape(c_pwd) +
          ";path=/;expires=" +
          exdate.toGMTString();
    },


    finish(){
      let key = localStorage.getItem('businessNo')
      if(!key){
        this.$message.error("链接已失效！")
        return;
      }
      let params = {
        'businessNo':this.businessNo
      }
      this.$apiFetch.post("/lockerInvite/inviteTaskBusiness", params).then((res) => {
        // this.sendEmail();
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        }else{
          localStorage.removeItem('businessNo');
          this.nextStep();
        }
      }).catch(err=>{
        this.$message.error("请求失败！")
      });
    },
    versionChooseNextStep(){
      if(this.versionInfo=='' || this.versionInfo == undefined || this.versionInfo == null){
        this.$message.error("请先选择版本");
        return;
      }
      let params = {
        'businessType':'ChooseVersion',
        'businessNo':this.businessNo,
        'chooseVersion':this.versionInfo,
      }
      this.commit(params)
      if(this.versionInfo == 40){
        this.step = 'chooseVersionPro'
      }else{
        let params = {
          'businessNo':this.businessNo,
          'businessType':'proVersion',
          'trace':10,
          'pandian':false
        }
        this.commit(params)
        this.nextStep()
      }
    },
    async addSchoolTask(){
      if(!this.businessNo){
        this.$message.error("注册链接已失效");
        return;
      }else if(!this.schoolTaskInfo.city){
        this.$message.error("请先选择城市");
        return;
      }else if(!this.schoolTaskInfo.schoolName){
        this.$message.error("请输入机构名称");
        return;
      }else if(!this.schoolTaskInfo.schoolTaskName){
        this.$message.error("请输入实验室名称");
        return;
      }

      let params = {
        'businessType':'TaskMessage',
        'businessNo':this.businessNo,
        'city':this.schoolTaskInfo.city,
        'schoolName':this.schoolTaskInfo.schoolName,
        'taskName':this.schoolTaskInfo.schoolTaskName
      }
      this.$apiFetch.post("/lockerInvite/preparationInvite", params).then((res) => {
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        } else {
          this.nextStep();
        }
      }).catch(err=>{
        this.$message.error("请求失败！")
      });
    },
    nextStep(){
      let tempStep = this.step;
      if(this.step == "chooseVersionPro"){
        tempStep = "versionChoose"
      }
      let index = this.stepArr.indexOf(tempStep);
      if(index!=-1 && index<this.stepArr.length && index+1<this.stepArr.length){
        this.step = this.stepArr[index+1]
      }
    },
    previousStep(){
      if(this.step == "chooseVersionPro"){
        this.step = "versionChoose"
        return;
      }
      if(this.step == "versionInfo" && this.versionInfo == 40){
        this.step = "chooseVersionPro"
        return;
      }
      let index = this.stepArr.indexOf(this.step);
      console.log(index)
      if(index!=-1 && index<this.stepArr.length && index-1>=0){
        this.step = this.stepArr[index-1]
      }
    },
    getLoker() {
      this.$apiFetch
          .get("/lockerCopywriting/list")
          .then((data) => {
            this.platformInfo = data.data[0];
            localStorage.setItem(
                "platformInfo",
                JSON.stringify(this.platformInfo)
            );
          })
          .catch((error) => {
            console.log(error);
          });
    },
    //选择地址
    chooseArea(value) {
      console.log(this.addressName);
      let chineseValue = this.$refs["refValue"].getCheckedNodes()[0].pathLabels;
      this.itemAddress.province = chineseValue[0];
      this.itemAddress.city = chineseValue[1];
      this.itemAddress.area = chineseValue[2];
      this.itemAddress.provinceId = value[0];
      this.itemAddress.cityId = value[1];
      this.itemAddress.areaId = value[2];
      let city = chineseValue[0]+chineseValue[1]+chineseValue[2];
      this.schoolTaskInfo.city = city;
    },
  },
};
</script>
<style lang="less" scoped>
.last-checkbox{
  margin-top: 22px;
}
.previous-btn{
  background-color: #fff;
}
.li-item{
  margin-top: 10px;
  font-size: 15px;
}
.high-light{
  color: #d14908;
}
.version-radio{
  margin-top: 20px;
}
.name{

    width: 100%;
    text-align: center;
    margin-top: 60px;

}
  .bottom-btn-parent{
    width: 90%;
    position: absolute;
    bottom: 40px;
  }
.bottom-btn{
  display: inline-block;
  width: 120px;
  float:right;
  right: 20px;
  margin-right: 20px;

}
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-item {
  flex-basis: 30%;
  margin: 20px 0px;
}
.div-item{
  margin-top: 50px
}
.h2-title-children-info{
  margin-top: 15px;
  /deep/ .el-input__inner{
    border-radius: 0px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
}
.record {
  position: fixed;
  bottom: 30px;
  text-align: center;
  margin: 0 auto;
  width: 100%;
}
.login-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
}
.main {
  background: url("../../assets/images/loginBgc.png") bottom;
  background-color: #f2f5fa;
  min-height: 100vh;
  .logo-title {
    display: flex;
    img {
      width: 24px;
      height: 24px;
      margin: 16px 10px 0 20px;
    }
    h2 {
      height: 32px;
      font-size: 20px;
      font-weight: 700;
      color: #333333;
      line-height: 32px;
      padding-top: 12px;
    }
  }
}
.login-content {
  // width: 1049px;
  // height: 598px;
  width: 54%;
  height: 55%;
  min-width: 600px;
  min-height: 538px;
  box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
  border-radius: 12px;
  overflow: hidden;
  margin: auto auto;
  // margin-top: 140px;
  position: relative;
  img.login-left {
    width: 47.8%;
    min-width: 301px;
    display: block;
    float: left;
    object-fit: cover;
    height: 100%;
  }
  .login-content-sysName {
    position: absolute;
    top: 156px;
    width: 47.8%;
    height: 100%;
    min-width: 401px;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    color: #fff;
    word-break: break-all;
    padding: 0 80px;
  }
  .login-info {
    overflow: hidden;
    padding: 40px 40px;
    position: relative;
    background: #fff;
    height: 100%;
    .accountName {
      color: #333;
    }
    h2 {
      font-size: 20px;
      font-weight: 700;
      line-height: 42px;
      letter-spacing: 2px;
      text-shadow: 0px 4px 20px rgba(16, 44, 91, 0.09);
    }
    .card-login {
      width: 0;
      height: 0;
      border-top: 126px solid #f0f5ff;
      border-left: 126px solid transparent;
      position: absolute;
      top: 0;
      right: 0;
    }
    img.card-icon {
      position: absolute;
      width: 125px;
      display: block;
      top: 0;
      right: 0;
    }
  }
}
.zcBox {
  padding: 40px 72px;
  width: 542px;
  //height: 598px;
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
  border-radius: 12px;

  .title {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 33px;
    letter-spacing: 2px;
  }

  .box {
    margin-top: 30px;

    .normalLine {
      display: flex;
      margin-top: 30px;

      .l_t {
        width: 70px;
        height: 20px;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }

      .r_t {
        margin-left: 19px;
        flex: 1;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        line-height: 20px;
      }
    }

    .input_line {
      margin-top: 30px;
      border-bottom: 1px solid #999;
      display: flex;
      padding-bottom: 10px;

      .l_t {
        width: 70px;
        height: 20px;
        font-size: 14px;
        color: #333;
        line-height: 20px;
      }

      .r_ipt {
        margin-left: 19px;
        flex: 1;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        line-height: 20px;
      }
    }

    ::-webkit-input-placeholder {
      color: #ccc;
      font-weight: 400;
    }
  }
  .requiedText{
    color: red;
  }
  //button {
  //  width: 100%;
  //  margin-top: 30px;
  //  height: 48px;
  //  background: #478aff;
  //  border-radius: 4px;
  //  text-align: center;
  //  line-height: 48px;
  //  font-size: 18px;
  //  color: #ffffff;
  //}
}
</style>